import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { Outlet } from "react-router-dom";
import { AdminLangProvider, useAdminLang } from "./AdminLangContext";
import { Globe } from "lucide-react";

interface AppLayoutProps {
  secret: string;
  onLogout: () => void;
}

const LANGUAGES = [
  { code: 'el', label: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

function LangSelector() {
  const { lang, setLang } = useAdminLang();
  const current = LANGUAGES.find((l) => l.code === lang) ?? LANGUAGES[0];

  return (
    <div className="relative flex items-center">
      <Globe className="h-3.5 w-3.5 text-muted-foreground mr-1.5" />
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="appearance-none bg-muted text-xs font-mono px-2 py-1 pr-6 rounded border-0 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.flag} {l.label}
          </option>
        ))}
      </select>
      <svg className="absolute right-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-muted-foreground pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
}

export function AppLayout({ secret, onLogout }: AppLayoutProps) {
  return (
    <AdminLangProvider>
      <SidebarProvider>
        <div className="flex min-h-screen w-full bg-background">
          <AppSidebar onLogout={onLogout} />
          <div className="flex flex-1 flex-col min-w-0">
            <header className="flex h-14 items-center gap-4 border-b bg-card px-4 sticky top-0 z-10">
              <SidebarTrigger />
              <div className="flex-1" />
              <div className="flex items-center gap-3">
                <LangSelector />
                <div className="text-xs text-muted-foreground font-mono bg-muted px-2 py-1 rounded">
                  Admin
                </div>
              </div>
            </header>
            <main className="flex-1 overflow-auto p-6">
              <Outlet context={{ secret }} />
            </main>
          </div>
        </div>
      </SidebarProvider>
    </AdminLangProvider>
  );
}
